"use client"

import { FileText } from "lucide-react"
import { Checkbox } from "@/components/ui/checkbox"
import type { TrashItem } from '@/api/trash'

interface TrashFileListProps {
  files: TrashItem[]
  selectedIds: string[]
  onSelectChange: (ids: string[]) => void
}

export function TrashFileList({
  files,
  selectedIds,
  onSelectChange,
}: TrashFileListProps) {
  const handleSelect = (id: string, checked: boolean) => {
    if (checked) {
      onSelectChange([...selectedIds, id])
    } else {
      onSelectChange(selectedIds.filter((fileId) => fileId !== id))
    }
  }

  if (!files.length) {
    return (
      <div className="py-10 text-center text-sm text-gray-500">
        回收站为空
      </div>
    )
  }

  return (
    <div className="divide-y divide-gray-100">
      {files.map((file) => (
        <div
          key={file.id}
          className={`grid grid-cols-[auto_1fr_200px_200px] gap-4 px-6 py-4 hover:bg-gray-50 transition-colors ${
            selectedIds.includes(file.id) ? "bg-blue-50/30" : ""
          }`}
        >
          {/* 复选框 */}
          <div className="flex items-center">
            <Checkbox
              checked={selectedIds.includes(file.id)}
              onCheckedChange={(checked) => handleSelect(file.id, checked as boolean)}
            />
          </div>

          {/* 文件信息 */}
          <div className="flex items-center gap-3 min-w-0">
            <FileText className="w-8 h-8 text-gray-400 flex-shrink-0" />
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">
                {file.fileName || file.shareName || file.id}
              </p>
            </div>
          </div>

          {/* 删除时间 */}
          <div className="flex items-center">
            <span className="text-sm text-gray-600">
              {new Date(file.deletedAt).toLocaleString("zh-CN")}
            </span>
          </div>

          {/* 清理时间 */}
          <div className="flex items-center">
            <span className="text-sm text-gray-600">
              {new Date(file.cleanupTime).toLocaleString("zh-CN")}
            </span>
          </div>
        </div>
      ))}
    </div>
  )
}

